import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const GroupHead = styled(Box)(({ theme }) => ({
	position: 'relative',
	paddingLeft: 16,
	paddingRight: 16,
	paddingTop: 12,
	paddingBottom: 4,
	'&:before': {
		content: '""',
		position: 'absolute',
		left: 16,
		right: 16,
		top: 8,
		height: '1px',
		backgroundColor: theme.palette.secondary.light,
	}
}));
